var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-6 offset-lg-3 col-12 p-0" }, [
        _c("div", { staticClass: "card shadow-sm" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-body" },
            [
              [
                _c("p", { staticClass: "font-weight-bold" }, [
                  _vm._v("สินเชื่อเงินสด NIMCAP")
                ]),
                _vm._v(" "),
                _vm._m(1)
              ],
              _vm._v(" "),
              [
                _c("p", { staticClass: "font-weight-bold" }, [
                  _vm._v("ผ่อนชำระรายสัปดาห์")
                ]),
                _vm._v(" "),
                _vm._m(2)
              ],
              _vm._v(" "),
              [
                _c("p", { staticClass: "font-weight-bold" }, [
                  _vm._v("ยอดผ่อนชําระ 275.73 บาท/สัปดาห์")
                ])
              ],
              _vm._v(" "),
              [
                _c("p", { staticClass: "font-weight-bold" }, [
                  _vm._v("รับเงินใน : บัญชีธนาคาร")
                ])
              ],
              _vm._v(" "),
              [
                _c("p", { staticClass: "font-weight-bold" }, [
                  _vm._v("วิธีชำระคืน")
                ]),
                _vm._v(" "),
                _vm._m(3)
              ]
            ],
            2
          )
        ]),
        _vm._v(" "),
        _vm._m(4)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("p", { staticClass: "text-center", staticStyle: { margin: "0px" } }, [
        _vm._v("ตรวจสอบรายละเอียดการกู้")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("จำนวนที่ขอสินเชื่อ "),
      _c("strong", [_vm._v("10,000 บาท")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("table", { staticClass: "table" }, [
      _c("tbody", [
        _c("tr", [
          _c("td", [_vm._v("อัตราดอกเบี้ยลดต้นลดดอก")]),
          _vm._v(" "),
          _c("td", [_vm._v("15% ต่อปี")])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("ค่าธรรมเนียมการใช้วงเงิน")]),
          _vm._v(" "),
          _c("td", [_vm._v("0.75%")])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("ค่าอากรแสตมป์")]),
          _vm._v(" "),
          _c("td", [_vm._v("0.05%")])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("ระยะเวลาผ่อนชำระ")]),
          _vm._v(" "),
          _c("td", [_vm._v("90 วัน")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticStyle: { "margin-left": "1rem" } }, [
      _c("li", [
        _vm._v("BeNeat จะหักเงินคืนจากรายได้ประจำสัปดาห์ ตามตารางการผ่อนชำระ")
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "ถ้าหากรายได้ประจำสัปดาห์ไม่เพียงพอ จะรวบยอด กับการเรียกเก็บในสัปดาห์ต่อไป"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card shadow-sm" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("p", [
          _vm._v(
            "ขั้นตอนสุดท้าย! กรุณากรอกข้อมูลส่วนตัวของคุณ เพื่อใช้พิจารณาให้สินเชื่อ"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce51eac4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce51eac4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nimcap/Components/Guarantor/Step8.vue
// module id = 2304
// module chunks = 0